import React from "react";
import WebHome from "./WebHome";
import WhoisAndromeda from "./WhoisAndromeda";
import Features from "./Features";
import ContactUs from "./ContactUs";
import Page7 from "../components/Page7";
import Header from "../components/Header";
import Page2 from "../components/Page2";
import Page3 from "../components/Page3";
import Page4 from "../components/Page4";
import Page5 from "../components/Page5";
import Page6 from "../components/Page6";
import Page2_1 from "../components/Page2_1";
import { Helmet } from 'react-helmet'

export default function WebSite() {
  return (
    <div>

<Helmet>
        {/* Title Tag */}
        <title>Andromeda-Sim - Premier SaaS Solution for Aviation Simulator Quality and Performance</title>

        {/* Meta Description */}
        <meta name="description" content="Andromeda-Sim is a premier SaaS solution designed to enhance simulator quality and performance. Offering features like Scheduler, Maintenance, QTG Tests, and Crew Enroll, we empower aviation training centers, flight schools, and aviation academies with innovative tools to optimize their simulator operations. Request a demo today!" />

        {/* Meta Keywords */}
        <meta name="keywords" content="Andromeda-Sim, SaaS solution for simulators, simulator quality, simulator performance, aviation training software, flight simulation, scheduler function, QTG tests, maintenance module, aviation simulators, flight training centers, crew enrollment, aviation academies, aviation software demo, simulator management" />

        {/* Open Graph Tags */}
        <meta property="og:title" content="Andromeda-Sim - Empowering Aviation Excellence" />
        <meta property="og:description" content="Andromeda-Sim offers cutting-edge solutions for simulator quality and performance, including Scheduler, QTG Tests, and Maintenance, helping aviation training centers optimize their operations." />
        <meta property="og:image" content="https://andromeda-sim.com/static/media/image12.9fb58f1f7c79c662795b.webp" />
        <meta property="og:url" content="https://andromeda-sim.com" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Tags */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Andromeda-Sim - Empowering Aviation Excellence" />
        <meta name="twitter:description" content="Andromeda-Sim offers cutting-edge solutions for simulator quality and performance, including Scheduler, QTG Tests, and Maintenance, helping aviation training centers optimize their operations." />
        <meta name="twitter:image" content="https://andromeda-sim.com/static/media/image12.9fb58f1f7c79c662795b.webp" />

        {/* Canonical Link */}
        <link rel="canonical" href="https://andromeda-sim.com" />

        {/* Structured Data */}
        <script type="application/ld+json">
          {`
            {
              "@context": "http://schema.org",
              "@type": "WebSite",
              "name": "Andromeda-Sim",
              "url": "https://andromeda-sim.com",
              "description": "Andromeda-Sim is a premier SaaS solution designed to enhance simulator quality and performance, empowering aviation training centers with features like Scheduler, Maintenance, and QTG Tests.",
              "sameAs": [
                "https://www.facebook.com/profile.php?id=61557870732734",
                "https://www.linkedin.com/company/andromeda-sim"
              ]
            }
          `}
        </script>
      </Helmet>
       
      <div id="home">
        <WebHome />
      </div>

      <div id="whoisandromeda">
      <Page2/>
      <Page2_1/>

         <Page7 />
         
        <Page3/>
       
      </div>

 

      <div id="contactus">
        <Page6 />
      </div>

   

     

      
    </div>
  );
}
